



































import Vue from 'vue';
import { mapGetters } from 'vuex';
import StudioMediaCard from '@/web/components/products/StudioMediaCard.vue';

export default Vue.extend({
  name: 'StudioProductFreeSample',
  components: { StudioMediaCard },
  computed: {
    ...mapGetters({
      product: 'product/product',
    }),
  },
});
